import type { ICellRendererParams } from 'ag-grid-community';
import { memo } from 'react';

import { useCoefficientsConfig } from '../../hooks/configuration';
import { useFilters } from '../../hooks/filters';

import { useWindowSize } from '@hooks/useWindowSize';
import TeamIdentifier from '@shared/Identifier/TeamIdentifier';
import type { Coefficient } from '@shared-types/coefficient.types';
import { CompetitionType } from '@shared-types/competition.types';

const Identifier = ({ value }: ICellRendererParams<Coefficient, Coefficient['member']>) => {
  const {
    configuration: { competitionType },
  } = useCoefficientsConfig();
  const { filtersActive } = useFilters();
  const { isMobile } = useWindowSize();
  const isClub = competitionType === CompetitionType.CLUB;

  return (
    <TeamIdentifier
      className='pk-py--0'
      team={value}
      badgeSize={isMobile ? 24 : 32}
      enableLink={isClub}
      showTeamCountry={isClub && !filtersActive}
    />
  );
};

export default memo(Identifier);
